import config from '@conf'
import { RequestRecord } from './request.record'
import get from 'lodash/get'

export class InvoiceRequestRecord extends RequestRecord {
  constructor (record = {}) {
    super(record)
    this._record = record
    this.invoice = get(record, 'details.invoice')
    this.amount = get(this.invoice, 'amount', '-')
    this.asset = get(this.invoice, 'asset', '-')
    this.invoiceNumber = get(this.invoice, 'details.invoice_number', '-')
    this.note = get(this.invoice, 'details.note', '-')
    this.invoiceFile = get(this.invoice, 'details.invoice_file', {})
    this.invoiceFileUrl = this.getInvoiceFileUrl()
    this.invoiceFileName = this.getInvoiceFile().name
    this.invoiceFileType = this.getInvoiceFile().type
    this.payer = get(this.invoice, 'payer_balance')
    this.receiver = get(this.invoice, 'receiver_balance')
    this.contractId = get(this.invoice, 'contract_id', '-')
  }

  getInvoiceFileUrl () {
    const key = get(this.invoiceFile, 'key')
    if (!key) return ''
    return `${config.FILE_STORAGE}/${key}`
  }

  getInvoiceFile () {
    const fileName = get(this.invoiceFile, 'name')
    const [name, type] = fileName.split(/\.(?=[^.]+$)/)
    return {
      name: name,
      type: type
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/records/invoice_request.record.js